import { ArcadeUser } from './ArcadeUser';
import { Countries, CountryOfResidence } from '@gif/shared-global';

export enum ArcadeLanguageEnums {
  EN = 'EN_US',
  ES = 'ES_US',
}

export interface HubContentQueryProps {
  uid?: string;
  language?: ArcadeLanguageEnums;
}

export interface RefreshProfileQueryProps {
  hardRefresh: boolean;
}

export interface SetCountryOfResidenceBody {
  countryName: string;
  countryCode: string;
  provinceName: string | null;
  provinceCode: string | null;
}

export interface GetApprovedCountriesResponse {
  success: boolean | string;
  reason: string; // TODO: create enum
  result: Countries;
}

export interface PostRefreshProfileResponse {
  success: boolean | string;
  reason: string;
  result: ArcadeUser;
}

export interface PutSetCountryOfResidenceResponse {
  success: boolean | string;
  reason: string;
}

export interface SetCountryOfResidenceQueryProps extends CountryOfResidence {
  uid: string;
}
